const i18nService = {
  defaultLanguage: "tr",

  languages: [
    {
      lang: "tr",
      name: "Türkçe",
      flag: "/assets/media/flags/218-turkey.svg",
    },
    // {
    //   lang: "ru",
    //   name: "русский",
    //   flag: "/assets/media/flags/248-russia.svg"
    // },
    {
      lang: "en",
      name: "English",
      flag: "/assets/media/flags/226-united-states.svg",
    },
    // {
    //   lang: "ch",
    //   name: "Mandarin",
    //   flag: "/assets/media/flags/034-china.svg"
    // },
    // {
    //   lang: "es",
    //   name: "Spanish",
    //   flag: "/assets/media/flags/128-spain.svg"
    // },
    // {
    //   lang: "jp",
    //   name: "Japanese",
    //   flag: "/assets/media/flags/063-japan.svg"
    // },
    // {
    //   lang: "de",
    //   name: "German",
    //   flag: "/assets/media/flags/162-germany.svg"
    // },
    // {
    //   lang: "fr",
    //   name: "French",
    //   flag: "/assets/media/flags/195-france.svg"
    // }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorage.getItem("language") || this.defaultLanguage;
  },
};

export default i18nService;
